import { render } from "./EmailVerificationView.vue?vue&type=template&id=0e65bd90&ts=true"
import script from "./EmailVerificationView.vue?vue&type=script&lang=ts"
export * from "./EmailVerificationView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__